import React from 'react';

// Stroke icons ported from the Claude Design handoff (Asset Lab vuesax
// style). Kept local to the module so the studio matches the mockup exactly.
type IconProps = { size?: number };

export const MagicIcon: React.FC<IconProps> = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path
      d="M3 13L11.5 4.5M11 3l.7 1.6L13.3 5.3 11.7 6 11 7.6 10.3 6 8.7 5.3 10.3 4.6 11 3z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
    <path d="M2.5 5l.4.9.9.4-.9.4-.4.9-.4-.9L1.2 6.3 2.1 5.9 2.5 5z" fill="currentColor" />
    <path d="M13.5 10l.3.7.7.3-.7.3-.3.7-.3-.7-.7-.3.7-.3.3-.7z" fill="currentColor" />
  </svg>
);

export const CloseIcon: React.FC<IconProps> = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path d="M3.5 3.5l9 9m0-9l-9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const PlusIcon: React.FC<IconProps> = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path d="M8 2.5v11M2.5 8h11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const HelpIcon: React.FC<IconProps> = ({ size = 13 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="6.25" stroke="currentColor" strokeWidth="1.3" />
    <path
      d="M6.35 6.2c0-.95.74-1.6 1.65-1.6.9 0 1.6.58 1.6 1.45 0 .78-.5 1.12-1.02 1.46-.5.32-.63.57-.63 1.04v.2"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    <circle cx="8" cy="11.4" r="0.78" fill="currentColor" />
  </svg>
);

export const GripIcon: React.FC<IconProps> = ({ size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="currentColor">
    <circle cx="6" cy="4" r="1.3" />
    <circle cx="10" cy="4" r="1.3" />
    <circle cx="6" cy="8" r="1.3" />
    <circle cx="10" cy="8" r="1.3" />
    <circle cx="6" cy="12" r="1.3" />
    <circle cx="10" cy="12" r="1.3" />
  </svg>
);

export const CameraIcon: React.FC<IconProps> = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path
      d="M1.5 5.5a1 1 0 0 1 1-1H4l1-1.5h6l1 1.5h1.5a1 1 0 0 1 1 1V12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1V5.5z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <circle cx="8" cy="8.75" r="2.3" stroke="currentColor" strokeWidth="1.2" />
  </svg>
);

export const CheckIcon: React.FC<IconProps> = ({ size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none">
    <path
      d="M2.5 6L5 8.5 9.5 4"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowDownIcon: React.FC<IconProps> = ({ size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none">
    <path
      d="M2.5 4.5L6 8l3.5-3.5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchIcon: React.FC<IconProps> = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <circle cx="7.5" cy="7.5" r="5" stroke="currentColor" strokeWidth="1.4" />
    <path d="M11.5 11.5L14 14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

export const PencilIcon: React.FC<IconProps> = ({ size = 12 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path
      d="M11 2.5l2.5 2.5M3 13l8.5-8.5 2.5 2.5L5.5 15.5H3V13z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
  </svg>
);

export const WarningIcon: React.FC<IconProps> = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path
      d="M8 1.8L15 14H1L8 1.8z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <path d="M8 6.2v3.4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    <circle cx="8" cy="11.6" r="0.85" fill="currentColor" />
  </svg>
);

export const KeyIcon: React.FC<IconProps> = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <circle cx="5.5" cy="5.5" r="3" stroke="currentColor" strokeWidth="1.3" />
    <path
      d="M7.6 7.6l5.4 5.4M11 11l1.3-1.3M12.6 12.6l1.1-1.1"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Scissors — the "cut out the subject / remove background" tool.
export const CutoutIcon: React.FC<IconProps> = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <circle cx="4" cy="4.5" r="1.8" stroke="currentColor" strokeWidth="1.2" />
    <circle cx="4" cy="11.5" r="1.8" stroke="currentColor" strokeWidth="1.2" />
    <path
      d="M5.6 5.7L13.5 11M5.6 10.3L13.5 5"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
);

// Corner brackets pointing outward — the "upscale / enlarge resolution" tool.
export const UpscaleIcon: React.FC<IconProps> = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path
      d="M6.5 2.5H2.5V6.5M9.5 2.5H13.5V6.5M6.5 13.5H2.5V9.5M9.5 13.5H13.5V9.5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Clock with a counter-clockwise arrow — the "History" tab.
export const HistoryIcon: React.FC<IconProps> = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path
      d="M2.5 8a5.5 5.5 0 1 0 1.7-3.97M2.5 3v2.3h2.3"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8 5.2V8l1.9 1.2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);

// Tray with a down arrow — the "Download" action.
export const DownloadIcon: React.FC<IconProps> = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path
      d="M8 2.5v7m0 0L5.3 6.8M8 9.5l2.7-2.7"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.8 11.5v1.2a.8.8 0 0 0 .8.8h8.8a.8.8 0 0 0 .8-.8v-1.2"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);

// Circular arrows — the "Reuse setup" / regenerate action.
export const RefreshIcon: React.FC<IconProps> = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path
      d="M12.6 6.5A5 5 0 0 0 3.6 5M3.4 9.5a5 5 0 0 0 9 1.5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8 3v3.4H9.4M3.2 13V9.6h3.4"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ExternalLinkIcon: React.FC<IconProps> = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path
      d="M6.5 3.5H3.5v9h9v-3"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 3.5H13V7M13 3.5L7.5 9"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Cloud with a check — the generation is saved to the Asset Lab (linked to a
// real cloud node). Doubles as the "Reveal in Asset Lab" affordance.
export const CloudLinkedIcon: React.FC<IconProps> = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path
      d="M4.7 11.8a2.6 2.6 0 0 1-.2-5.18 3.4 3.4 0 0 1 6.5-.7 2.5 2.5 0 0 1 .4 4.96"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4.5 11.8h7" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    <path
      d="M6.2 9.1l1.2 1.2 2.4-2.6"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Document — the generation lives only on this device (local / temporary),
// not yet saved into the Asset Lab.
export const LocalFileIcon: React.FC<IconProps> = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path d="M4.5 2.5h4l3 3v8h-7z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
    <path
      d="M8.5 2.5v3h3"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Tray with an up arrow — the "Save to assets" action (push into the library),
// mirroring DownloadIcon's tray-with-down-arrow.
export const SaveToAssetsIcon: React.FC<IconProps> = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <path
      d="M8 9.5v-7m0 0L5.3 5.2M8 2.5l2.7 2.7"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.8 11.5v1.2a.8.8 0 0 0 .8.8h8.8a.8.8 0 0 0 .8-.8v-1.2"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);
